import {Col, Row} from "react-bootstrap";
import React from "react";
import Back from "../layout/template/back";
import {Link} from "react-router-dom";
import AppRoute from "../../utils/AppRoute";


const RegistrationDone = () => {

        return (
            <>
                <Row>
                    <Col lg={6}>
                        <Row>
                            <Col>
                                <Back />
                            </Col>
                        </Row>

                        <Row className={'mt-5 mb-2'}>
                            <Col>
                                <h2 className={'fw-bold'}>Grazie per la registrazione!</h2>
                            </Col>
                        </Row>

                        <Row className={'mb-5'}>
                            <Col>
                                <p>
                                    Benevenuto/a<br/>
                                    Siamo felici di accoglierti nel nostro shop.
                                </p>
                                <p>
                                    Per continuare con il tuo acquisto procedi nell’inserimento dei tuoi dati appena registrati. <br/>
                                    Procedi quindi con il login sulla piattaforma.
                                </p>
                                <Link to={AppRoute.LOGIN} className={'btn btn-primary px-5 fw-bold'}>Login</Link>
                            </Col>
                        </Row>

                    </Col>
                </Row>
            </>

        );
}

export default RegistrationDone;